import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Vault } from "lucide-react";
import { toast } from "sonner";
import { API, fmtErr } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <Vault className="h-6 w-6 text-emerald-600" />
          <span className="font-heading font-bold text-lg">{t("brand")}</span>
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">{t("auth.forgot_title")}</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">{t("auth.forgot_sub")}</p>
        {sent ? (
          <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-4" data-testid="forgot-sent-message">
            {t("auth.check_email")}
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="fp-email">{t("landing.email")}</Label>
              <Input id="fp-email" data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1" />
            </div>
            <Button data-testid="forgot-submit-button" type="submit" disabled={busy}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white h-11">
              {busy ? t("common.loading") : t("auth.send_link")}
            </Button>
          </form>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" data-testid="back-to-login-link" className="text-sm text-emerald-700 hover:underline">
            {t("auth.back_login")}
          </Link>
        </div>
      </div>
    </div>
  );
}
